import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { StoreKeys } from '../../../../hooks/useStore/state';
import { useStore } from '../../../../hooks/useStore/useStore';
import { LeapFrogRating as LeapFrogRatings } from '../../../../models/ProviderDetails';
import { phoneOnly } from '../../../ConstantsStyles';
import {
  FillBar,
  RatingHeader,
  RatingText,
  ratingContainerStyle,
} from './LeapFrogRating.styles';

type Props = {
  leapFrogRatings: LeapFrogRatings[];
};

export const LeapFrogRating = ({ leapFrogRatings }: Props) => {
  const isWidget = useStore(StoreKeys.IS_WIDGET);
  const phoneScreen = useMediaQuery(phoneOnly) || isWidget;

  return (
    <Flex
      css={{
        'abyss-flex-root': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          backgroundColor: 'white',
          boxSizing: 'border-box',
        },
      }}
      data-testid="leapfrog-rating-container"
      direction="row"
    >
      {leapFrogRatings.map((rating) => {
        const ratingAsInt = parseInt(rating.rawValue, 10);
        return (
          <Flex
            css={ratingContainerStyle(phoneScreen)}
            direction="column"
            key={`leapfrog-rating-${rating.rawValue}`}
          >
            <Text css={RatingHeader}>{rating.displayField}</Text>
            <Flex direction="row">
              {[0, 1, 2, 3].map((num: number) => (
                <Box
                  color={
                    num < ratingAsInt && ratingAsInt <= 4
                      ? '$core.color.green.100'
                      : '$core.color.neutral.30'
                  }
                  css={{
                    'abyss-box-root': {
                      ...FillBar,
                      marginRight: num === 3 ? '0' : '$sm',
                      '@media (max-width: 464px)': {
                        width: '79.75px',
                      },
                    },
                  }}
                  key={num}
                />
              ))}
            </Flex>
            <Text css={RatingText}>{rating.ratingValue}</Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
